import { StatusCodes } from 'http-status-codes';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';
import { axiosInstance } from './axiosInstance';

const requestOtp = async (data) => {
  let response;

  try {
    response = await axiosInstance.post('/login', data);
  } catch (err) {
    const errorResp = err?.response?.data?.message;
    if (errorResp) {
      response = err.response;
    } else {
      response = handleErrorResponse(err, data);
    }
  }

  return response;
};

export const requestLoginOtp = async ({
  firstName,
  lastName,
  email,
  msisdn,
  contact,
  ref,
  privacyConsent,
  cid
}) => await requestOtp({
  firstName,
  lastName,
  email,
  msisdn,
  contact,
  ref,
  privacyConsent,
  cid
});

export const requestLoginOtpResend = async (input) => {
  const response = await requestOtp(input);
  return response;
};

export const submitLoginOtpResponse = async (ref, code) => {

  let response;

  try {

    response = await axiosInstance.post('/login', { ref, code });

    if (response.status !== StatusCodes.OK || !response.data) {
      throw new Error('SubmitOtpResponse');
    }

  } catch (err) {
    const errorResponse = err.response || {};
    if ([StatusCodes.BAD_REQUEST, StatusCodes.TOO_MANY_REQUESTS].includes(errorResponse.status)) {
      response = {
        data: errorResponse.data || {}
      };
    } else if (errorResponse.status === StatusCodes.REQUEST_TIMEOUT) {
      response = {
        data: { message: errorResponse.data?.message || {} }
      };
    } else {
      response = handleErrorResponse(err);
    }
  }

  const data = response.data;

  if (!data.accessToken) {
    return data;
  }

  return {
    token: data.accessToken,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    msisdn: data.msisdn,
    ttl: data.ttl,
    timestamp: new Date().getTime(),
    privacyConsent: data.privacyConsent,
    verification: data.verification,
    routingDecision: data.routingDecision,
    defaultBusinessId: data.defaultBusinessId,
    defaultProductKey: data.defaultProductKey,
    inProgressBusinessId: data.inProgressBusinessId,
    businesses: data.businesses,
    allBusinessLenderStatuses: data.allBusinessLenderStatuses
  };
};
